import React from 'react';

const labels = {
  ne: {
    title: 'लक्ष्य तथा प्रगति',
    subtitle: '२०३०, २०४० र २०५० का लक्ष्यहरू।',
    progress: 'प्रगति',
  },
  en: {
    title: 'Goals and Progress',
    subtitle: 'Milestones for 2030, 2040, and 2050.',
    progress: 'Progress',
  },
};

const SectorGoals = ({ goals, language = 'ne' }) => {
  const t = labels[language] || labels.ne;

  if (!goals || goals.length === 0) {
    return null;
  }

  return (
    <section className="sector-goals" id="sector-progress">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </div>

        <div className="goals__timeline">
          {goals.map((goal, index) => (
            <div key={index} className="goal-item">
              <div className="goal-item__card">
                <div className="goal-item__header">
                  <h3 className="goal-item__year">{goal.year}</h3>
                </div>

                <h4 className="goal-item__title">{goal.title}</h4>
                <p className="goal-item__description">{goal.description}</p>

                <div className="goal-item__progress">
                  <div className="progress-header">
                    <span className="progress-label">{t.progress}</span>
                    <span className="progress-value">{goal.progress}%</span>
                  </div>
                  <div className="progress-bar">
                    <div
                      className="progress-bar__fill"
                      style={{ width: `${goal.progress}%` }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectorGoals;
